"use client";

import { motion } from "framer-motion";
import DownloadCTA from "@/components/shared/DownloadCTA";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const perks = ["Keine In-App-Käufe", "Kein Abo", "Keine versteckten Kosten"];

export default function FreeBanner() {
  return (
    <section className="cv-auto relative bg-accent text-paper overflow-hidden">
      {/* Dezenter Verlauf für Tiefe, gleiche Palette wie der Hero */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 80% at 50% 0%, rgba(124,58,237,0.38) 0%, rgba(124,58,237,0.12) 42%, transparent 70%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <motion.div
          variants={stagger(0.09)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="flex flex-col items-center text-center gap-7"
        >
          <motion.h2
            variants={fadeUp}
            className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]"
          >
            Ist kostenlos.
            <br />
            Bleibt kostenlos.
          </motion.h2>

          <motion.p variants={fadeUp} className="text-paper/80 text-lg leading-relaxed max-w-lg">
            ncrechner hilft dir kostenfrei, deinen Weg ins Medizinstudium zu
            planen. Ohne Kompromisse, ohne Kleingedrucktes.
          </motion.p>

          <motion.ul variants={fadeUp} className="flex flex-wrap justify-center gap-x-8 gap-y-3">
            {perks.map((perk) => (
              <li key={perk} className="flex items-center gap-2.5 text-sm font-medium text-paper/90">
                <svg className="w-4 h-4 shrink-0" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M3 8.5l3.5 3.5L13 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="square" />
                </svg>
                {perk}
              </li>
            ))}
          </motion.ul>

          <motion.div variants={fadeUp}>
            <DownloadCTA variant="paper" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
